import { ActivatedRouteSnapshot } from '@angular/router';

export const canEnterVismaExpense = (
  route: ActivatedRouteSnapshot
): boolean => {
  const queryParams = route.queryParams;
  return !!queryParams['visma_code'];
};
